import {
  initialState,
  Actions,
  State,
  GET_ONE_SUPPORT_TASK,
  GET_ONE_SUPPORT_TASK_SUCCESS,
  GET_ONE_SUPPORT_TASK_ERROR,
  RESET_GET_ONE_SUPPORT_TASK,
} from '../../types/support-tasks/get-one'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_SUPPORT_TASK:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ONE_SUPPORT_TASK_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ONE_SUPPORT_TASK_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ONE_SUPPORT_TASK:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
